/*global DPI_STATS_TMOUT_MS */
import React, { useContext } from "react";
import Report from "views/Statistics/Report/Hourly/component";
import ActionsContext from "common/ActionsContext";
import help from "help/viewDPIHourlyVolume.md";
import CategoryDetailsModal from "../CategoryDetails";
import { atBqnTarget, expressTarget } from "common/api";
import { parseShareInSpeed } from "../api";
import * as d3 from "d3";
import useProfile from "common/hooks/useProfile";
import View from "common/View";

const doSpeedShareRetrieval = (
  target,
  hours = 72,
  categories = 20,
  directions = "all",
  filter = "all",
  bqnId,
  mode
) =>
  expressTarget( target ).then( expressedTarget =>
    ifCl.run(
      atBqnTarget(
        `show statistics dpi speed ${expressedTarget} hours ${hours} interval 60 categories ${
          categories - 1
        } direction ${directions} interval-speed 5 ${filter === "auto" ? "udrs-auto" : ""}`,
        mode,
        bqnId
      ),
      { timeout: DPI_STATS_TMOUT_MS }
    )
  );

const retrieval = ({ target, hours, categories, directions, filter, bqnId, mode }) =>
  doSpeedShareRetrieval(target, hours, categories, directions, filter, bqnId, mode)
    .then(parseShareInSpeed)
    .then((speeds) => ({ speeds }))
    .catch((error) => console.error(error) || error);

const mbToGb = ({ total, dpi }) => ({
  total: (total / 1000).toFixed(2),
  dpi: (dpi / 1000).toFixed(2),
});

const sumTotalAndDPI = (items) =>
  items.reduce(
    (prev, { total = 0, dpi = 0 }) => ({
      total: prev.total + total,
      dpi: prev.dpi + dpi,
    }),
    { total: 0, dpi: 0 }
  );

export const TotalVolumeVsDPI = ({ speeds }) => (
  <TotalVolumeVsDPIResult {...mbToGb(sumTotalAndDPI(speeds))} />
);

const formatOnlyDecimals = d3.format(",.2f");

const formatDecimals = (value) =>
  value === undefined ? "--" : formatOnlyDecimals(value);

const TotalVolumeVsDPIResult = ({ total, dpi }) => (
  <h4 className="align-left">
    Total volume: {formatDecimals(total)} GB - DPI sample:{" "}
    {formatDecimals(dpi)} GB
  </h4>
);

const enabledFeatures = (dpiPerUserEnabled) => ({
  policyType: false,
  hours: true,
  directions: true,
  categories: true,
  filter: true,
  target: dpiPerUserEnabled === true,
  output: false,
});

const DPIHourlyVolume = ({returnView = null}) => {
  const profile = useProfile() || {};
  const areClientsInspectable = profile.dpiEnabled === true;
  const actions = useContext(ActionsContext);
  const openCategoryDetail = (category, params) =>
    category.name !== 'REST' &&
    actions.send("open-category", {
      category,
      params,
    });
  return (
    <View id="viewDPIHourlyVolume"
      title="DPI hourly statistics"
      mdHelp={help}
      backButton={returnView !== null}
      subtitle={<><code>right-click</code> in the area for a DPI category inside the chart or in the labels for each category above the chart</>}
    >
      <Report
        returnView={returnView}
        graphTitle={null}
        provider={retrieval}
        onSeriesInspect={openCategoryDetail}
        enabled={enabledFeatures(areClientsInspectable)}
        actions={actions}
        Totals={TotalVolumeVsDPI}
      />
      <CategoryDetailsModal sourceView="viewDPIHourlyVolume" />
    </View>
  );
};

export default DPIHourlyVolume;
